import classNames from 'classnames/bind';
import styles from './Button.module.scss';

const cx = classNames.bind(styles);

function Button({ children, long, light, onClick }) {
  return (
    <button onClick={onClick} className={cx('button', { long: long, light: light })}>
      {children|| "Submit"}
    </button>
  );
}

export default Button;
